import { appConfig } from '../../configs/app'
import type { ServerFile } from '../../types/server/models/_base'
import axios from 'axios'

/**
 * Download a file from the server
 */
export const useFile = (filePath: string) => {}

/**
 * Handle files upload
 */
export const UploadFiles = async (files: File[]): Promise<any> => {
	const formData = new FormData()
	files.forEach((file) => {
		formData.append('files', file)
	})

	const response = await axios.post(`${appConfig.apiUrl}/upload`, files, {
		headers: {
			'Content-Type': 'multipart/form-data',
			Authorization: `Bearer ${localStorage.getItem('token')}`
		},
	})

	if (response.status !== 200) {
		throw new Error('Failed to upload files')
	}

	console.log({ response })
	return response.data
}
